import { grey } from '@mui/material/colors'

export const defaultComponentLevelTheme = {
  MuiOutlinedInput: {
    styleOverrides: {
      root: {
        fontSize: '12px',
      },
    },
  },
  MuiInputBase: {
    styleOverrides: {
      root: {
        fontSize: '12px',
      },
    },
  },
  MuiAutocomplete: {
    styleOverrides: {
      root: {
        '& .MuiOutlinedInput-root.MuiInputBase-sizeSmall': {
          paddingBlock: '5px !important',
        },
        fontSize: '12px',
      },
      paper: {
        '& li': {
          fontSize: '12px',
        },
      },
    },
  },
  MuiFormLabel: {
    styleOverrides: {
      root: {
        fontSize: '13px',
      },
    },
  },
  MuiTableCell: {
    styleOverrides: {
      root: {
        fontSize: '12px',
        padding: '0px 10px',
        border: '0.2px  solid rgba(224, 224, 224, 1)',
      },
    },
  },
  MuiMenuItem: {
    styleOverrides: {
      root: {
        fontSize: '12px',
      },
      paper: {
        '& li': {
          fontSize: '12px',
        },
      },
    },
  },
  MuiButton: {
    defaultProps: {
      size: 'small',
      root: {
        '&.MuiButton-contained': {
          color: 'white',
        },
        '&.MuiButton-outlined, &.MuiButton-text': {
          color: '#secondary.main',
        },
      },
    },
  },
  MuiAppBar: {
    styleOverrides: {
      root: {
        color: '#444444',
      },
    },
  },
}

export const defaultTheme = {
  palette: {
    primary: { main: '#27104E' },
    secondary: { main: '#0E84CF' },
    info: { main: grey[700] },
    text: {
      primary: '#27104E',
      secondary: '#656D92',
      error: '#FF0000',
      warning: '#FFCC00',
      white: '#fff',
      lightblue: 'F9F9FF',
    },
    avatar: {
      bg: '#554400',
    },
    border: {
      primary: '#6C47E4',
      secondary: '#DEE2E6',
      tertiary: '#888888',
    },
  },
  typography: {
    fontFamily: 'Plus Jakarta Sans',
    fontWeightLight: 400,
    fontWeightRegular: 500,
    fontWeightMedium: 600,
    fontWeightBold: 700,
    fontSize: 14,
  },
  components: defaultComponentLevelTheme,
}
